import styled from 'styled-components';

interface ProfileInitialProps {
	size: number;
	fontSize: number;
}
export const ProfileInitial = styled.div<ProfileInitialProps>`
	width: ${({ size }) => size}px;
	height: ${({ size = 32 }) => size}px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	font-size: ${({ fontSize }) => fontSize}px;
	color: ${(p) => p.theme.gray[1000]};
`;
